import React from 'react';

interface Props {
    url: string;
    text?: string;
}

const Link = ({ url, text }: Props) => (
    <a
        key={`link-${url}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-link"
    >
        {text || url}
    </a>
);

export default Link;
